exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-download-progess-wrapper[data-v-a372446c]{height:100%;font-size:15px}.result-download-progess-wrapper .close-button[data-v-a372446c]{position:absolute;right:20px;bottom:20px}.fail-excel-number-wrapper[data-v-a372446c]{height:110px;overflow-y:scroll;border:1px solid #cecece;margin-top:4px;padding:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
